import {Component, HostBinding, OnInit} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {Constants} from "../../../../src/app/common/constants";
import {OverlayContainer} from "@angular/cdk/overlay";
import {CommonDataService} from "../../../../src/app/common/common-data.service";
import {CommonService} from "../../../../src/app/common/common.service";
import {SiteDetails} from "../../../../src/app/common/site-details";
import {Observable} from "rxjs/internal/Observable";

@Component({
  selector: 'app-root2',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

  @HostBinding('class') componentCssClass;

  title = 'setup-new-password';
  constants = Constants;
  brand: string;
  username: string;
  footer: string;
  logo: string;
  httpParams:any;
  loading:boolean = true;


  constructor(private overlayContainer: OverlayContainer, private commonDataService: CommonDataService, private commonService: CommonService, private httpClient: HttpClient) {}

  ngOnInit() {
    this.getParams();
    this.setUpBranding();
    this.getUsername();
    this.setUpSiteDetails();
  }

  getUsername() {
    let paramValue, firstTimeLogin;
    if (this.httpParams) {
      paramValue = this.httpParams.get('username');
      firstTimeLogin = this.httpParams.get('firstTimeLogin');
    }
    this.username = paramValue;
    this.commonDataService.isFirstTimeLogin = firstTimeLogin === 'true' ? true : false;
  }

  setUpSiteDetails() {
    this.commonDataService.siteDetails = new SiteDetails();
    this.getSiteDetailsByBrand(this.brand).subscribe((result: number) => {
      this.commonDataService.siteDetails.maxPasswordLength = result;
      this.loading = false;
    }, error => {
      console.log("unable to retrieve site details");
    })
  }

  getSiteDetailsByBrand(brand: string): Observable<any> {
    return this.httpClient.get<Number>('/setUpNewPassword/getSiteDetails/' + brand);
  }

  setUpBranding() {
    this.brand = this.httpParams.get('brand') ? this.httpParams.get('brand') : this.constants.BRAND_WESTNET;
    if (document.location.host.indexOf('iinet.net.au') != -1) {
      this.brand = this.constants.BRAND_IINET;
    } else if (document.location.host.indexOf('internode.on.net') != -1) {
      this.brand = this.constants.BRAND_INTERNODE;
    } else if (document.location.host.indexOf('tpg.com.au') !== -1) {
      this.brand = this.constants.BRAND_TPG
    }
    this.componentCssClass = this.brand + '-theme';
    this.overlayContainer.getContainerElement().classList.add(this.brand + '-theme');
    if (null != this.brand) {
      if (Constants.BRAND_IINET === this.brand) {
        this.logo = '/assets/iinet-logo.svg';
        this.footer = '2021 © iiNet Limited. ACN 068 628 937';
        this.createScript('GTM-FH77');
        this.createLink('apple-touch-icon', 'https://assets.iinet.net.au/website/_shared/favicon/iinet-v1.0/apple-touch-icon.png', ['180x180']);
        this.createLink('icon', 'https://assets.iinet.net.au/website/_shared/favicon/iinet-v1.0/favicon-32x32.png', ['32x32']);
        this.createLink('icon', 'https://assets.iinet.net.au/website/_shared/favicon/iinet-v1.0/favicon-16x16.png', ['16x16']);
        this.createLink('manifest', 'https://assets.iinet.net.au/website/_shared/favicon/iinet-v1.0/site.webmanifest');
        this.createLink('mask-icon', 'https://assets.iinet.net.au/website/_shared/favicon/iinet-v1.0/safari-pinned-tab.svg', null, '#ff8200');
        this.createLink('shortcut icon', 'https://assets.iinet.net.au/website/_shared/favicon/iinet-v1.0/favicon.ico');
        this.createMeta('apple-mobile-web-app-title', 'iiNet');
        this.createMeta('application-name', 'iiNet');
        this.createMeta('msapplication-TileColor', '#ff8200');
        this.createMeta('msapplication-config', 'https://assets.iinet.net.au/website/_shared/favicon/iinet-v1.0/browserconfig.xml');
      } else if (Constants.BRAND_INTERNODE === this.brand) {
        this.logo = '/assets/internode-logo.svg';
        this.footer = 'Copyright © Internode Pty Ltd. ACN 052 008 581';
        this.createScript('GTM-L43V');
        this.createLink('apple-touch-icon', 'https://www.internode.on.net/sites/internode/files/favicons/apple-touch-icon.png', ['180x180']);
        this.createLink('icon', 'https://www.internode.on.net/sites/internode/files/favicons/favicon-32x32.png', ['32x32']);
        this.createLink('icon', 'https://www.internode.on.net/sites/internode/files/favicons/favicon-16x16.png', ['16x16']);
        this.createLink('manifest', 'https://www.internode.on.net/sites/internode/files/favicons/site.webmanifest');
        this.createLink('mask-icon', 'https://www.internode.on.net/sites/internode/files/favicons/safari-pinned-tab.svg', null, '#eb5903');
        this.createLink('shortcut icon', 'https://www.internode.on.net/sites/internode/files/favicons/favicon.ico', ['48x48']);
        this.createMeta('apple-mobile-web-app-title', 'internode');
        this.createMeta('application-name', 'internode');
        this.createMeta('msapplication-TileColor', '#eb5903');
        this.createMeta('msapplication-TileImage', 'https://www.internode.on.net/sites/internode/files/favicons/mstile-144x144.png');
      } else if (Constants.BRAND_WESTNET === this.brand) {
        this.logo = '/assets/westnet-logo.svg';
        this.footer = '2021 © Westnet Pty Ltd. ABN 50 086 416 908.';
        this.createScript('GTM-8TV35');
        this.createLink('apple-touch-icon', 'https://assets.iinet.net.au/website/_shared/favicon/westnet-v1.0/apple-touch-icon.png', ['180x180']);
        this.createLink('icon', 'https://assets.iinet.net.au/website/_shared/favicon/westnet-v1.0/favicon-32x32.png', ['32x32']);
        this.createLink('icon', 'https://assets.iinet.net.au/website/_shared/favicon/westnet-v1.0/favicon-16x16.png', ['16x16']);
        this.createLink('manifest', 'https://assets.iinet.net.au/website/_shared/favicon/westnet-v1.0/site.webmanifest');
        this.createLink('mask-icon', 'https://assets.iinet.net.au/website/_shared/favicon/westnet-v1.0/safari-pinned-tab.svg', null, '#ff8200');
        this.createLink('shortcut icon', 'https://assets.iinet.net.au/website/_shared/favicon/westnet-v1.0/favicon.ico');
        this.createMeta('apple-mobile-web-app-title', 'Westnet');
        this.createMeta('application-name', 'Westnet');
        this.createMeta('msapplication-TileColor', '#002c77');
        this.createMeta('msapplication-config', 'https://assets.iinet.net.au/website/_shared/favicon/westnet-v1.0/browserconfig.xml');
      } else if (Constants.BRAND_TPG === this.brand) {
        this.logo = '/assets/tpg-logo-white.svg';
        this.footer = 'Copyright © 2021 TPG Internet Pty Ltd ABN 15 068 383 737 - All Rights Reserved';
        this.createScript('GTM-MPKGLW');
        this.createLink('apple-touch-icon', 'assets/favicon/tpg/apple-touch-icon.png', ['180x180']);
        this.createLink('icon', 'assets/favicon/tpg/tpgfavicon.ico', ['32x32']);
        this.createLink('icon', 'assets/favicon/tpg/tpgfavicon.ico', ['16x16']);
        this.createLink('manifest', 'assets/favicon/tpg/site.webmanifest');
        this.createLink('mask-icon', 'assets/favicon/tpg/safari-pinned-tab.svg', null, '#ff8200');
        this.createLink('shortcut icon', 'assets/favicon/tpg/tpgfavicon.ico');
        this.createMeta('apple-mobile-web-app-title', 'TPG');
        this.createMeta('application-name', 'TPG');
        this.createMeta('msapplication-TileColor', '#53006a');
        this.createMeta('msapplication-config', 'assets/favicon/tpg/browserconfig.xml');
      }
    }
  }

  createLink(rel: string, href: string, sizes?: string[], color?: string) {
    let link: HTMLLinkElement = document.createElement('link');
    link.href = href;
    link.rel = rel;
    if (sizes) {
      for (let size of sizes) {
        if (link.sizes != null) {
          link.sizes.add(size);
        }
      }
    }
    document.head.appendChild(link);
  }

  createMeta(name: string, content: string) {
    let meta: HTMLMetaElement = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    document.head.appendChild(meta);
  }

  createScript(id) {
    let gtmScript = '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n' +
      '      new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n' +
      '    j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n' +
      '    \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n' +
      '  })(window,document,\'script\',\'dataLayer\',\'XXXXXX\');';
    gtmScript = gtmScript.replace('XXXXXX', id);
    let script: HTMLScriptElement = document.createElement('script');
    script.innerText = gtmScript;
    document.head.appendChild(script);
  }

  getParams() {
    const url = window.location.href;
    if (url.includes('?')) {
      this.httpParams = new HttpParams({ fromString: url.split('?')[1] });
    }
  }
}

